import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import "./Chat.scss";
import { AiOutlineSend } from "react-icons/ai";
import socketIOClient from "socket.io-client";
import { BASE_URL } from "../../config";
import { getUserId } from "../../utils/authManager";
import { _listedChatedUser, _chatList, updateRealtimeChatSuccess } from "../../store/users/actions";


const Chat = (props) => {
  const [state, setState] = useState({
    totalUsers: [],
    newMessage: "",
    chattingUser: {},
    message: "",
    nowChatedWith: "",
  });
  const socket = socketIOClient(BASE_URL);
  useEffect(async () => {
    if (!props.user.loadedUser) {
      await props._listedChatedUser();
    }
    const userId = await getUserId();
    if (!userId) return;
  }, []);

  useEffect(() => {
    socket.on("chats", (data) => {
      setState({
        ...state,
        newMessage: data,
      });
    });
  }, []);
  const addForChat = async (data) => {
    await props._chatList(data._id);
    setState({
      ...state,
      nowChatedWith: data._id,
      chattingUser: data,
    });
  };

  const sendChat = async () => {
    const data = {
      message: state.message,
      user_id: getUserId(),
      chat_with: state.chattingUser._id,
      chatType: getUserId(),
    }
    socket.emit("chats", data);
    setState({
      ...state,
      message: "",
    });
    props.updateRealtimeChatSuccess(data);
  };

  const handleChange = (e) => {
    setState({
      ...state,
      message: e.target.value,
    });
  };

  return (
    <div className="Chat">
      <div id="frame">
        <div id="sidepanel">
          <div id="search">
            <label for="">
              <i class="fa fa-search" aria-hidden="true"></i>
            </label>
            <input type="text" placeholder="Search contacts..." />
          </div>
          <div id="contacts">
            <ul>
              {props.user.loadedUser && props.user.chatedUser.length
                ? props.user.chatedUser.map((user) => {
                    const name = user?.added?.name
                      ? user?.added?.name
                      : user?.addedBy?.name;
                    const userDetls =
                      typeof user?.added === "object"
                        ? user?.added
                        : user?.addedBy;
                    return (
                      <li
                        class="contact"
                        key={user?.added?._id}
                        onClick={() => addForChat(userDetls)}
                      >
                        <div class="wrap">
                          <span class="contact-status online"></span>
                          <img
                            src="http://emilcarlsson.se/assets/louislitt.png"
                            alt=""
                          />
                          <div class="meta">
                            <p class="name">{name}</p>
                            <p class="preview">You just got LITT up, Mike.</p>
                          </div>
                        </div>
                      </li>
                    );
                  })
                : null}
            </ul>
          </div>
        </div>
        {Object.keys(state.chattingUser).length ? (
          <div class="content">
            <div class="contact-profile">
              <img
                src="http://emilcarlsson.se/assets/harveyspecter.png"
                alt=""
              />
              <p>{state.chattingUser.name}</p>
              <div class="social-media">
                <i class="fa fa-facebook" aria-hidden="true"></i>
                <i class="fa fa-twitter" aria-hidden="true"></i>
                <i class="fa fa-instagram" aria-hidden="true"></i>
              </div>
            </div>
            <div class="messages">
              <ul>
                {!props.user.allChats.length ? (
                  <div>Start your chat..</div>
                ) : (
                  props.user.allChats.map((chat) => {
                    const checkMymsg = chat.chatType === getUserId();
                    return (
                      <li
                        className={checkMymsg ? "replies" : "sent"}
                        key={chat._id}
                      >
                        <img
                          src="http://emilcarlsson.se/assets/harveyspecter.png"
                          alt=""
                        />
                        <p>{chat.chat? chat.chat : chat.message}</p>
                      </li>
                    );
                  })
                )}
              </ul>
            </div>
            <div class="message-input">
              <div class="wrap">
                <input
                  type="text"
                  placeholder="Write your message..."
                  onChange={handleChange}
                  value={state.message}
                />
                <button
                  class="submit d-flex justify-content-center align-items-center"
                  onClick={() => sendChat()}
                  disabled={!state.message}
                >
                  <AiOutlineSend />
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div>Added someone for chat</div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, {
  _listedChatedUser,
  _chatList,
  updateRealtimeChatSuccess
})(Chat);
